// extracted by mini-css-extract-plugin
module.exports = {"configs__container":"configs_configs__container__1Wqa8","configs__header":"configs_configs__header__23idY","configs__title":"configs_configs__title__YYl39"};